import { jsx as _jsx } from "react/jsx-runtime";
import { getFieldTitle } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { DisplayText } from "../../DisplayText";
export var HeaderField = function (_a) {
    var uiSchema = _a.uiSchema, _b = _a.formContext, formContext = _b === void 0 ? {} : _b;
    // @ts-ignore TODO: Typescript upgrade
    var title = getFieldTitle(uiSchema, formContext);
    return (_jsx(DisplayText, { element: "h3", size: "small", children: title }));
};
